<template>
  <!--
      作者：luoyiming
      时间：2019-10-24
      描述：支付宝推广人列表
  -->
  <div class="product-list">
    <!--搜索表单-->
    <!-- <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        
        <el-form-item label="商品名称"
          ><el-input
            size="small"
            v-model="searchForm.product_name"
            placeholder="请输入商品名称"
          ></el-input
        ></el-form-item>
        <el-form-item>
          <el-button
            size="small"
            type="primary"
            icon="el-icon-search"
            @click="onSubmit"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div> -->
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
        >
          <el-table-column prop="name" label="渠道来源"></el-table-column>
          <el-table-column prop="usercount" label="用户数"></el-table-column>
          <el-table-column prop="all" label="订单数"></el-table-column>
          <el-table-column prop="payment" label="待付款"></el-table-column>
          <el-table-column prop="delivery" label="待发货"></el-table-column>
          <el-table-column prop="received" label="待收货"></el-table-column>
          <el-table-column prop="examine" label="待审核"></el-table-column>
          <el-table-column prop="haveInHand" label="进行中"></el-table-column>
          <el-table-column prop="returned" label="待归还"></el-table-column>
          <el-table-column prop="complete" label="已完成"></el-table-column>
          <el-table-column prop="cancel" label="已取消"></el-table-column>
          <el-table-column prop="Returning" label="归还中"></el-table-column>
          <el-table-column prop="refuse" label="拒绝归还"></el-table-column>
           <el-table-column prop="reject" label="已驳回"></el-table-column>
          <el-table-column prop="canceling" label="取消中"></el-table-column>
          <el-table-column prop="yqcount" label="已逾期"></el-table-column>
          <el-table-column prop="yqprobability" label="逾期率"></el-table-column>
          <!-- <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <div class="table-btn-column">
                <el-button
                  @click="viewOrder(scope.row)"
                  type="text"
                  size="small"
                  >查看订单</el-button
                >
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>
    <!--分页-->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, prev, pager, next, jumper,sizes"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import PromotionApi from "@/api/promotion.js";
export default {
  components: {},
  data() {
    return {
      /*是否正在加载*/
      loading: true,
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索参数*/
      searchForm: {
        product_name: "",
        category_id: "",
      },
      /*列表数据*/
      tableData: [],
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      // display_Port  1 支付宝  2 H5
      Params.display_Port = 2
      self.loading = true;
      PromotionApi.getCountList(Params, true)
        .then((data) => {
          self.loading = false;
          self.tableData = data.data.listdata;
          self.totalDataNumber = data.data.list.total;
          self.product_count = data.data.product_count;
        })
        .catch((error) => {
          self.loading = false;
        });
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.dialogBox {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/promotion/promotion/h5stat.vue